
export interface ContactInputDto {
    id?: number;
    recaptchaToken: string;

    phoneCountryCode: PhoneCountryCode;
    phone: string;
    name: string;
    email: string;
    message: string;
}
export interface ContactOutputDto {
    id: number;
    isActive: boolean;

    phoneCountryCode: PhoneCountryCode;
    phone: string;
    name: string;
    email: string;
    message: string;
}

export enum PhoneCountryCode {
    Afghanistan = 93,
    Albania = 355,
    Algeria = 213,
    Andorra = 376,
    Angola = 244,
    Argentina = 54,
    Armenia = 374,
    Australia = 61,
    Austria = 43,
    Azerbaijan = 994,
    Bahrain = 973,
    Bangladesh = 880,
    Belarus = 375,
    Belgium = 32,
    Belize = 501,
    Benin = 229,
    Bhutan = 975,
    Bolivia = 591,
    BosniaAndHerzegovina = 387,
    Botswana = 267,
    Brazil = 55,
    Brunei = 673,
    Bulgaria = 359,
    BurkinaFaso = 226,
    Burundi = 257,
    Cambodia = 855,
    Cameroon = 237,
    Canada_UnitedStates = 1,
    Chad = 235,
    Chile = 56,
    China = 86,
    Colombia = 57,
    CostaRica = 506,
    Croatia = 385,
    Cuba = 53,
    Cyprus = 357,
    CzechRepublic = 420,
    Denmark = 45,
    Ecuador = 593,
    Egypt = 20,
    ElSalvador = 503,
    Estonia = 372,
    Ethiopia = 251,
    Finland = 358,
    France = 33,
    Georgia = 995,
    Germany = 49,
    Ghana = 233,
    Greece = 30,
    Guatemala = 502,
    Honduras = 504,
    HongKong = 852,
    Hungary = 36,
    Iceland = 354,
    India = 91,
    Indonesia = 62,
    Iran = 98,
    Iraq = 964,
    Ireland = 353,
    Israel = 972,
    Italy = 39,
    Japan = 81,
    Jordan = 962,
    Kazakhstan = 7,
    Kenya = 254,
    Kuwait = 965,
    Kyrgyzstan = 996,
    Laos = 856,
    Latvia = 371,
    Lebanon = 961,
    Liberia = 231,
    Libya = 218,
    Lithuania = 370,
    Luxembourg = 352,
    Macau = 853,
    Madagascar = 261,
    Malaysia = 60,
    Maldives = 960,
    Mali = 223,
    Malta = 356,
    Mauritania = 222,
    Mauritius = 230,
    Mexico = 52,
    Moldova = 373,
    Monaco = 377,
    Mongolia = 976,
    Montenegro = 382,
    Morocco = 212,
    Mozambique = 258,
    Myanmar = 95,
    Namibia = 264,
    Nepal = 977,
    Netherlands = 31,
    NewZealand = 64,
    Nicaragua = 505,
    Nigeria = 234,
    NorthKorea = 850,
    NorthMacedonia = 389,
    Norway = 47,
    Oman = 968,
    Pakistan = 92,
    Panama = 507,
    Paraguay = 595,
    Peru = 51,
    Philippines = 63,
    Poland = 48,
    Portugal = 351,
    Qatar = 974,
    Romania = 40,
    Russia = 7,
    Rwanda = 250,
    SaudiArabia = 966,
    Senegal = 221,
    Serbia = 381,
    Singapore = 65,
    Slovakia = 421,
    Slovenia = 386,
    SouthAfrica = 27,
    SouthKorea = 82,
    Spain = 34,
    SriLanka = 94,
    Sudan = 249,
    Sweden = 46,
    Switzerland = 41,
    Syria = 963,
    Taiwan = 886,
    Tajikistan = 992,
    Tanzania = 255,
    Thailand = 66,
    Tunisia = 216,
    Turkey = 90,
    Turkmenistan = 993,
    Uganda = 256,
    Ukraine = 380,
    UnitedArabEmirates = 971,
    UnitedKingdom = 44,
    Uruguay = 598,
    Uzbekistan = 998,
    Venezuela = 58,
    Vietnam = 84,
    Yemen = 967,
    Zambia = 260,
    Zimbabwe = 263
}
